import { Link } from 'react-router-dom';
import { Brand } from '../components/Brand';

/** Keep invitation-only access explicit; never claim an email was sent without an API. */
export function AccessHelpPage({ reset = false }: { reset?: boolean }) {
  return (
    <main className="App rfp-login">
      <section className="rfp-login__card">
        <Brand />
        <h1>{reset ? 'Reset password' : 'Create account'}</h1>
        <p className="rfp-login__intro">
          {reset
            ? 'Contact your workspace administrator to recover access to your account. Self-service password reset is not available yet.'
            : 'Waterfall workspaces are invitation only. Ask your workspace administrator for an invitation, then open the secure link in your email to create your account.'}
        </p>
        <div className="wf-auth-links">
          <Link to="/login">Back to sign in</Link>
          <Link to="/">Continue as guest</Link>
        </div>
      </section>
    </main>
  );
}
